import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import CloseIcon from "@mui/icons-material/Close";
import "./MapStylesSidebar.css";

const MapStylesSidebar = ({
  showMapStylesSidebar,
  handleStyleChange,
  selectedStyle,
  toggleMapStylesSidebar,
  onShowNavbarMenu,
}) => {
const styles = [
  { value: "mapbox://styles/mapbox/satellite-streets-v11", label: "Carte satellite", slug: "satellite" },
  { value: "mapbox://styles/mapbox/streets-v11", label: "Carte routière", slug: "routiere" },
  { value: "mapbox://styles/mapbox/outdoors-v11", label: "Courbes de niveau", slug: "outdoors" },
  { value: "mapbox://styles/mapbox/light-v10", label: "Fond clair", slug: "clair" },
];
  const returnToMenu =()=>{
    toggleMapStylesSidebar();
      onShowNavbarMenu();
    }
      return (
    <div
      className={`sidebar-MapStyle ${showMapStylesSidebar ? "open" : ""}`}
    >
      <div className="drag-comp-header">
        <KeyboardDoubleArrowLeftIcon
            onClick={returnToMenu}
          className="drag-comp-returnIcon"
        />
        <div className="drag-comp-title">Fond de carte</div>
        <CloseIcon
          onClick={toggleMapStylesSidebar}
          className="drag-comp-closeIcon"
        />
      </div>
      <div className="mapStyleSidebar-body" data-testid="mapstyles-sidebar-list">
        {styles.map((style) => (
          <div
            key={style.value}
            className="mapStyleSidebar-body-item"
            data-testid={`mapstyles-sidebar-option-${style.slug}`}
          >
            <input
              type="radio"
              id={style.value}
              name="mapStyle"
              value={style.value}
              onChange={() => handleStyleChange(style.value)}
              checked={selectedStyle === style.value}
              style={{
                accentColor: style.value === "" ? "red" : "blue",
              }}
               data-testid={`mapstyles-sidebar-radio-${style.slug}`}
            />
            <label
              htmlFor={style.value}
            >
              {style.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MapStylesSidebar;
